import { distance, closest } from 'fastest-levenshtein';

export const findClosestMatchScore = (query = '', list = []) => {
  if (!query || !list.length) return null;

  const target = query.toLowerCase();

  const scored = list.map(item => {
    const itemLower = item.toLowerCase();
    let score = 0;

    // 1. Substring containment boost (Fixes the fire vs firetruck problem)
    if (itemLower.includes(target) || target.includes(itemLower)) {
      score += 500;
    }

    // 2. Exact match jackpot
    if (itemLower === target) {
      score += 1000;
    }

    // 3. Normalized Levenshtein (Fixes the typo problem)
    const d = distance(itemLower, target);
    const maxLen = Math.max(itemLower.length, target.length);
    const similarity = maxLen === 0 ? 1 : 1 - d / maxLen;

    // Add the similarity weight (scales from 0 to 100)
    score += similarity * 100;

    return { item, score };
  });

  // Sort descending by score
  const best = scored.sort((a, b) => b.score - a.score)[0];

  return best && best.score > 0 ? best.item : null;
};

export const findClosestMatch = (query = '', list = []) => {
  return closest(query, list) ?? null;
};
